import React, { memo } from 'react'
import { Trans } from 'react-i18next'

export const TextDecoration = memo(({
    label
}: {
    label?: string
}) => {
    return (
        <>
            {
                <Trans
                    i18nKey={label}
                    components={{
                        i: <div className='italic' />,
                        b: <div className='font-bold' />,
                        u: <div className="underline" />
                    }}
                />
            }
        </>
    )
})